export default "__VITE_ASSET__02784688__"